import type { ComponentType } from 'react';
import { getYearlyDaysFromDate } from '../../utils/utils';
import ArrayField from '../inputs/ArrayField';
import ButtonGroupField from '../inputs/ButtonGroupField';
import CallContent, { type CallContentConfig } from '../inputs/CallContentField';
import CheckBoxField from '../inputs/CheckboxField';
import DateField from '../inputs/DateField';
import DatesMismatchWarning from '../inputs/DatesMismatchWarning';
import MonthlyValuesField from '../inputs/MonthlyValuesField';
import NumberField from '../inputs/NumberField';
import PersistentSoilingProgress from '../inputs/PersistentSoilingProgress';
import PersistentSoilingRecommendations from '../inputs/PersistentSoilingRecommendations';
import RadioField from '../inputs/RadioField';
import RainBiasCorrectionWarning from '../inputs/RainBiasCorrectionWarning';
import RainRecommendationField, { RainRecommendationMessage } from '../inputs/RainRecommendationField';
import SelectField from '../inputs/SelectField';
import SoilingRatioMultiSelect from '../inputs/SoilingRatioMultiSelect';
import SpecialArrayField from '../inputs/SpecialArrayField';
import SpecialMultiSelect from '../inputs/SpecialMultiSelect';
import SwitchField from '../inputs/SwitchField';
import TextField from '../inputs/TextField';
import UploadField from '../inputs/UploadField';
import type { FieldComponentProps } from './types';

const ArrayFieldWithDays = ({ field }: FieldComponentProps) => <ArrayField field={field} getYearlyDaysFromDate={getYearlyDaysFromDate} />;

const CallContentWithSchema = ({ field }: FieldComponentProps) => <CallContent field={field as unknown as CallContentConfig} />;

export const fieldRegistry: Record<string, ComponentType<FieldComponentProps>> = {
  text: TextField,
  number: NumberField,
  array: ArrayFieldWithDays,
  sarray: ArrayFieldWithDays,
  special_array: SpecialArrayField,
  checkbox: CheckBoxField,
  date: DateField,
  select: SelectField,
  multiSelectSpecial: SpecialMultiSelect,
  soilingRatioMultiSelect: SoilingRatioMultiSelect,
  switch: SwitchField,
  callContent: CallContentWithSchema,
  upload: UploadField,
  monthlyValues: MonthlyValuesField,
  buttonGroup: ButtonGroupField,
  radio: RadioField,
  persistentSoilingRecommendations: PersistentSoilingRecommendations,
  persistentSoilingProgress: PersistentSoilingProgress,
  rainRecommendation: RainRecommendationField,
  rainRecommendationMessage: RainRecommendationMessage,
  rainBiasCorrectionWarning: RainBiasCorrectionWarning,
  datesMismatchWarning: DatesMismatchWarning,
};
